
import CeisaBarangImporIndex from "@/components/exim/ceisa/barang_impor/CeisaBarangImporIndex.vue";
import CeisaBarangImporCreate from "@/components/exim/ceisa/barang_impor/CeisaBarangImporCreateNew.vue";
import CeisaBarangImporUpload from "@/components/exim/ceisa/barang_impor/CeisaBarangImporUpload.vue";

let CeisaBarangImporRoute= [
 
     
    {
      path: '',
      meta: {
        title: "Ceisa Barang Impor",
      },
      name: "CeisaBarangImporIndex",
      component: CeisaBarangImporIndex
    },
 
     
    {
      path: 'create/:id',
      meta: {
        title: "Ceisa Barang Impor Create",
      },
      name: "CeisaBarangImporCreate",
      component: CeisaBarangImporCreate
    },
    {
      path: 'upload',
      meta: {
        title: "Ceisa Barang Impor Upload",
      },
      name: "CeisaBarangImporUpload",
      component: CeisaBarangImporUpload
    },
 
     
    
]

export default CeisaBarangImporRoute
  